import DashedTitle from '@/common/components/base/dashedTitle/DashedTitle';
import BulletTypography from '@/common/components/base/typography/BulletTypography';
import Typography from '@/common/components/base/typography/Typography';
import { ShowIncidentParticipantsDataCardProps } from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard.type';
import React from 'react';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';

const ShowIncidentParticipantsDataCard: React.FC<
  ShowIncidentParticipantsDataCardProps
> = ({ title, data, children }) => {
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="purple-3"
      borderRadius={8}
      p={16}
      mb={20}
    >
      {title ? <DashedTitle title={title} /> : ''}
      <Flex direction="column" gap={16} mt={18}>
        {data
          ?.filter((item) => item?.value)
          ?.map((item) => (
            <Flex
              alignItems="center"
              justifyContent="space-between"
              key={item?.label}
            >
              <BulletTypography
                backgroundColor="purple-3"
                textStyle="b2"
                color="black-3"
              >
                {item?.label}
                {item?.label?.endsWith(':') || item?.label?.endsWith('؟')
                  ? null
                  : ' :'}
              </BulletTypography>
              <Typography
                textStyle="b2"
                color="black-1"
                className={css({
                  textWrap: 'wrap',
                  maxWidth: '150px',
                })}
              >
                {item?.value}
              </Typography>
            </Flex>
          ))}
        {children}
      </Flex>
    </Box>
  );
};
export default ShowIncidentParticipantsDataCard;
